export interface IFolder {
	name: string
	entries: (File | IFolder)[]
}

export function isFolder(f: any): f is IFolder {return f && typeof f.name === "string" && Array.isArray(f.entries)}

/**
 * Produit un arbre d'objets IFolder et File à partir d'un DataTransfer.
 */
export function getFilesOnDrop(data: DataTransfer): Promise<(File | IFolder)[]> {
	return new Promise((resolve: (value: (File | IFolder)[]) => void, reject: (reason?: any) => void) => {
		const result: (File | IFolder)[] = [];
		const items = data.items;
		let tasksCount = 0;
		const errCb = (err: any) => {
			tasksCount = -99;
			reject(err);
		};
		for (let i = 0; i < items.length; i++) {
			const item = items[i];
			if (item.kind === 'file') {
				//FileSystemHandle Ne fonctionne pas si drop d'une image d'un autre onglet par exemple
				// if (item.getAsFileSystemHandle) {
				// 	tasksCount++;
				// 	item.getAsFileSystemHandle().then(async (h) => {
				// 		async function readHandles(handle: FileSystemFileHandle | FileSystemDirectoryHandle, to: (File | IFolder)[]) {
				// 			if (handle instanceof FileSystemFileHandle) {
				// 				to.push(await handle.getFile())
				// 			} else if (handle instanceof FileSystemDirectoryHandle) {
				// 				const folder: IFolder = {name: handle.name, entries: []};
				// 				to.push(folder)
				// 				for await (const ch of (handle as any /*typage TS*/).values()) {
				// 					await readHandles(ch, folder.entries);
				// 				}
				// 			}
				// 		}
				//
				// 		await readHandles(h, result);
				// 		if (--tasksCount === 0) resolve(result);
				// 	})
				// } else {
				const entry = item.webkitGetAsEntry ? item.webkitGetAsEntry() as WebKitEntry : null;
				if (entry) {
					//Api webkitGetAsEntry en priorité pour capter les dossiers du FS.
					function scanEntry(entry: WebKitEntry, list: (File | IFolder)[]) {
						if (entry.isFile) {
							tasksCount++;
							(entry as WebKitFileEntry).file((file: File) => {
								if (tasksCount === -99) return; //Echec
								list.push(file);
								if (--tasksCount === 0) resolve(result);
							}, errCb);
						} else if (entry.isDirectory) {
							const folder: IFolder = {
								name: entry.name,
								entries: []
							};
							list.push(folder);
							tasksCount++;
							const reader = (entry as WebKitDirectoryEntry).createReader();
							const readerCb = (entries: WebKitEntry[]) => {
								if (tasksCount === -99) return; //Echec
								if (entries.length === 0) {
									if (--tasksCount === 0) resolve(result);
								} else {
									for (let entry of entries) scanEntry(entry, folder.entries);
									reader.readEntries(readerCb, errCb);
								}
							}
							reader.readEntries(readerCb, errCb);
						}
					}

					scanEntry(entry, result);
				} else {
					const file = item.getAsFile();
					if (file) result.push(file);
				}
				//	}
			}
		}
		if (tasksCount === 0) resolve(result);
	});
}

export namespace FILES {
	/** Retourne true si le mime candidate est autorisée dans la whiteList, false si non, null si les informations fournies sont insuffisantes */
	export function isMimeTypeAllowed(candidate: string, whiteList: string[]): boolean | null {
		if (!candidate || !whiteList) return null;
		let i = 0;
		const s = whiteList.length;
		while (i < s) {
			if (candidate.startsWith(whiteList[i]) && (whiteList[i].length === candidate.length || /\W/.test(candidate[whiteList[i].length]))) break;
			i++;
		}
		return i >= s ? false : true;
	}
}